import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { BsModalService, BsModalRef, ModalDirective } from 'ngx-bootstrap/modal';


export enum TypeModal {
  AGENTES,
  ESTADISTICOS,
  HORARIOS,
  INCIDENCIAS,
  REPORTE_AGENTES,
  OTRA2

}

@Component({
  selector: 'app-dashboard-monitor',
  templateUrl: './dashboard-monitor.component.html',
  styleUrls: ['./dashboard-monitor.component.scss']
})
export class DashboardMonitorComponent implements OnInit {

  @ViewChild('modalsMonitor') modalsMonitor: ModalDirective;
  title: string;
  typeMo: number;
  typeModel = TypeModal;

  public route_var: any;
  public currentUrl: string;

  constructor(private modalService: BsModalService) {
    this.route_var = false;
  }

  ngOnInit() {
  }

  fade_out(val) {
    this.route_var = val;
  }

  openModal(type: number) {  

    switch (type) {
      case TypeModal.AGENTES:
        this.title = "LISTADO DE AGENTES";
        this.typeMo = TypeModal.AGENTES;
        break;
      case TypeModal.ESTADISTICOS:
        this.title = "ESTADISTICOS EN VIVO";
        this.typeMo = TypeModal.ESTADISTICOS;
        break;
      case TypeModal.HORARIOS:
        this.title = "ADMINISTRACIÓN DE HORARIOS DE EMERGENCIA";
        this.typeMo = TypeModal.HORARIOS;
        break;
      case TypeModal.INCIDENCIAS:
        this.title = "CONTROL DE INCIDENCIAS TÉCNICAS";
        this.typeMo = TypeModal.INCIDENCIAS;
        break;
      case TypeModal.REPORTE_AGENTES:
        this.title = "SAID";
        this.typeMo = TypeModal.REPORTE_AGENTES;
        break;
      default:
        this.title = "NO HAY TITULO";
        break;

    }
    this.modalsMonitor.show();
  }

  hideModal(): void {
    this.modalsMonitor.hide();
  }

}



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/admin/monitor-agents/dashboard-monitor/dashboard-monitor.component.ts